const PrescriptionValidation = {
  IMPEDITIVE: {
    key: 'IMPEDITIVO',
    description: 'Cannot Prescribe',
  },
  ALERT: {
    key: 'ALERTA',
    description: 'Can prescribe with alerts',
  },
  INVALID: {
    key: 'INVALIDO',
    description: 'Cannot prescribe, there are informations to fulfill',
  },
  LOADING: {
    key: 'LOADING',
    description: 'Loading validation',
  },
  TYPING: {
    key: 'DIGITANDO',
    description: 'Cannot Prescribe',
  },
  OK: {
    key: 'OK',
    description: 'Can prescribe',
  },
};

const VALIDATION_ALERT_IMPEDITIVE = 'IMPEDITIVO';
const VALIDATION_ALERT_WARNING = 'ALERTA';

export {
  PrescriptionValidation,
  VALIDATION_ALERT_IMPEDITIVE,
  VALIDATION_ALERT_WARNING,
};
